import React, { PropsWithChildren, SetStateAction, useContext, useEffect, useRef, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { Pressable, ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Image } from 'expo-image';

const styles = StyleSheet.create({
});

interface PasswordShowHideButtonProps {
  passwordShown: boolean,
  setPasswordShown: (value: SetStateAction<boolean>) => void,
  largeKey?: boolean,
};

export function PasswordShowHideButton({
  passwordShown,
  setPasswordShown,
  largeKey = false,
}: PasswordShowHideButtonProps) : React.ReactNode {

  const ref = useRef<React.ComponentRef<typeof Pressable>>(null);

  useEffect(() => {
    if (AppUtilities.isWeb() && ref.current) {
      // TODO: https://github.com/necolas/react-native-web/issues/2828
      if (typeof (ref.current as any).setAttribute === 'function') {
        (ref.current as any).setAttribute("title", passwordShown ? "Hide password" : "Show password");
      }
    }
  }, [ref, passwordShown]);

  return (
    <Pressable onPress={() => setPasswordShown(!passwordShown)} hitSlop={AppConsts.HIT_SLOP_SMALL} ref={ref}>
      <Image
        style={[largeKey ? AppConstants.STYLES.imageKey : AppConstants.STYLES.imageKeySmall, { opacity: passwordShown ? 1 : 0.25 }]}
        source={largeKey ? require('@/assets/images/minis/key.png') : require('@/assets/images/minis/keysmall.png')}
        alt={passwordShown ? "Hide password" : "Show password"}
        accessibilityLabel={passwordShown ? "Hide password" : "Show password"}
      />
    </Pressable>
  );
};
